import { foodImage, logo, cardfood1, cardfood2, cardfood3 } from "@/assets";

const Template2 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const title = previewData?.title || (isStrictPreview ? "No provide" : "VOUCHER");
  const customerName =
    previewData?.customerName || (isStrictPreview ? "No provide" : "Royel Tanduri");
  const code = previewData?.code || (isStrictPreview ? "No provide" : "32154232");
  const paymentText = previewData?.paymentMethods?.length
    ? previewData.paymentMethods.map(m => m.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(", ")
    : isStrictPreview
      ? "No provide"
      : "Cash Only";
  const orderTypeText = previewData?.orderTypes?.length
    ? `For ${previewData.orderTypes.map(t => t.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(" / ")} only`
    : isStrictPreview
      ? "No provide"
      : "For dine in only ( not for Takeaway or Delivery )";
  const isConjunction =
    previewData?.isConjunction !== null && previewData?.isConjunction !== undefined
      ? Boolean(previewData?.isConjunction)
      : previewData?.is_conjunction !== null && previewData?.is_conjunction !== undefined
        ? Boolean(previewData?.is_conjunction)
        : !isStrictPreview;
  const conjunctionText = isConjunction ? "Not conjunction with any other offer" : null;
  const expiryDate = previewData?.expiryDate || (isStrictPreview ? "No provide" : "12/05/2026");
  const templateNote =
    previewData?.templateNote ||
    previewData?.template_note ||
    (previewData?.message && previewData.message !== title ? previewData.message : null);
  const voucherItems = previewData
    ? (previewData.voucherItems || [])
    : (isStrictPreview ? [] : [{ menu_item: { name: "Coca-Cola" }, variant: { name: "Medium" } }]);

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="voucher-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex bg-white"
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        >
          <div className="absolute inset-0 bg-black/40"></div>
        </div>
        <div className="absolute left-10 h-full flex flex-col justify-around py-4 z-20">
          <div className="w-20 h-20 rounded-full border-4 border-white overflow-hidden shadow-lg ml-8">
            <img
              src={cardfood1}
              alt="Food 1"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-24 h-24 rounded-full border-4 border-white overflow-hidden shadow-lg -ml-2">
            <img
              src={cardfood2}
              alt="Food 2"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-20 h-20 rounded-full border-4 border-white overflow-hidden shadow-lg ml-10">
            <img
              src={cardfood3}
              alt="Food 3"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div
          className="absolute inset-0 bg-white ml-auto w-[74%] z-10"
          style={{ clipPath: "polygon(20% 0, 100% 0, 100% 100%, 5% 100%)" }}
        >
          <div className="flex flex-col h-full pl-24 pr-10 py-8 text-black">
            {/* Header Section */}
            <div>
              <h1 className="text-3xl font-bold text-[#003B4A] uppercase tracking-tight leading-none mb-1">
                {title}
              </h1>
              <p className="text-lg font-serif italic text-gray-700">
                {customerName}
              </p>
              <p className="text-base font-normal text-gray-800">
                Code: {code}
              </p>
              {templateNote ? (
                <p className="text-sm font-medium italic text-gray-800 mt-0.5">
                  &quot;{templateNote}&quot;
                </p>
              ) : null}
            </div>
            {((paymentText && paymentText !== "Not provided" && paymentText !== "No provide") ||
              (orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide") ||
              conjunctionText ||
              (expiryDate && expiryDate !== "N/A" && expiryDate !== "Not provided" && expiryDate !== "No provide") ||
              (voucherItems && voucherItems.length > 0)) && (
              <div className="mt-auto text-[11px] leading-tight text-gray-800">
                <p className="mb-1 font-medium">-Terms & Conditions-</p>
                <ul className="list-disc list-inside space-y-0.5 ml-1">
                  {paymentText && paymentText !== "Not provided" && paymentText !== "No provide" && <li>{paymentText}</li>}
                  {orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide" && <li>{orderTypeText}</li>}
                  {conjunctionText && <li>{conjunctionText}</li>}
                  {expiryDate && expiryDate !== "N/A" && expiryDate !== "Not provided" && expiryDate !== "No provide" && <li>Exp. Date: {expiryDate}</li>}
                  {voucherItems.map((item, index) => (
                    <li key={index}>
                      Item: {item?.menu_item?.name || item?.name || ""}
                      {item?.variant?.name ? ` (${item.variant.name})` : item?.variant_name ? ` (${item.variant_name})` : ""}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template2;
